import React from 'react';
import { Button, Select } from '@uclaea/react-component-library';

interface BulkActionsProps {
  bulkAction: string;
  setBulkAction: (action: string) => void;
  onSubmit: () => void;
  busy?: boolean;
  allowUndo?: boolean;
}

const bulkActionOptions = [
  { label: 'Select Action...', id: 'none', value: '' },
  { label: 'Download Selection', id: 'download', value: 'DOWNLOAD' },
  { label: 'Check In', id: 'checkin', value: 'CHECK_IN' },
  { label: 'Undo Check In', id: 'undo', value: 'UNDO_CHECK_IN' },
];

const BulkActions: React.FC<BulkActionsProps> = ({ bulkAction, setBulkAction, onSubmit, busy = false, allowUndo = true }) => (
  <div className='bulk-actions'>
    <div className='bulk-actions-select'>
      <Select
        label="Action"
        value={!allowUndo && bulkAction === 'UNDO_CHECK_IN' ? '' : bulkAction}
        disabled={busy}
        onChange={e => setBulkAction(e.target.value)}
        options={bulkActionOptions.filter(option => allowUndo || option.value !== 'UNDO_CHECK_IN')}
      />
    </div>
    <Button variant="primary" label={busy ? "Saving…" : "Submit"} disabled={busy || !bulkAction || (!allowUndo && bulkAction === 'UNDO_CHECK_IN')} onClick={onSubmit} />
  </div>
);

export default BulkActions;
